import React from 'react';
import { useTheme } from '@material-ui/core';
import { TaxiCompanyList } from '../../../../../services/taxi/GetDirectionAndFare/models/getFareSamplesParams';
import { AMCCaution } from './AMCCaution';
import { useCautionStyles } from './Cautions';

interface Props {
  isMeterFare: boolean,
  /** 仮予約画面で表示するタクシー会社名 */
  companyDisplayName: string,
  /** AMCをサポートする事業者の場合 */
  isSupportAMC?: boolean,
  /** 本予約画面か */
  isReservationPage?: boolean,
  /** タクシー会社 */
  company: TaxiCompanyList
}

/** ハイヤー・タクシー予約画面の注意事項のコンポーネント。 */
export const CautionsEn: React.FC<Props> = (props: Props) => {
  const theme = useTheme();
  const classes = useCautionStyles(theme);

  return (
    <div className={classes.root} data-cy="cautions-area">
      <span className={classes.bold}>&lt; Important points &gt;</span>
      <ul className={classes.unorderedList}>
        <li>
          A booking is a direct contract between the limousine or taxi operating company and the customer.
        </li>
        <li className={classes.redFont}>
          The information you entered will be provided to the limousine or taxi operating company. In addition, the email address entered on this screen will also be communicated to ANA for handling of inquiries, etc., but this information is usually deleted within one year.
        </li>
        {/** AMCサポート事業者の場合には文言を追加する。本予約画面のみ表示する */}
        {props.isSupportAMC && props.isReservationPage &&
          <li>
            The ANA Mileage Club membership number (10 digits) entered on this screen will be communicated to ANA for Mileage settlement.
          </li>
        }
        <li className={classes.redFont}>
          Please note that a booking is not confirmed even when the booking request is complete. A booking is confirmed with the “Confirmation email” sent by the limousine or taxi operating company.
        </li>
        <li>
          You are requested to verify your email address each time you make a booking.
        </li>
        <li>
          A 100% cancellation fee will be charged for cancellation without notice and cancellation on the day of service.
        </li>
        <li>
          No driver waiting fee at the airport will be charged due to a delayed flight and no cancellation fee will be charged if you are unable to use the service due to cancellation of your flight.
          <br />
          However, ANA will not communicate such information to the limousine or taxi operating company. Please contact the limousine or taxi operating company.
        </li>
        <li>
          We cannot guarantee plane ticket reservations even if the service is not in time for your flight’s departure time due to a traffic jam, etc.
        </li>
        <li>
          Please pay to the driver at point of service.
        </li>
        <li>
          Stopovers to places other than your pick-up and drop-off location are not included. If you wish to make a stopover, please inquire with the limousine or taxi operating company.
        </li>
        {/* メーター料金の場合には注意書きを増やします */}
        {props.isMeterFare &&
          <li>
            Taxi meter charges are approximate based on the assumed travel distance and may differ from actual charges due to the road situation, etc. In addition, expressway tolls, pick-up charges, waiting and stopping due to traffic lights or traffic jams, etc., have not been considered.&nbsp;
            Charges will differ depending on taxi companies and regions so please consider these simply as reference amounts. Actual charges will be settled based on the meter at the time you ride.
          </li>
        }
        {/** 伊予鉄タクシーの場合には高速道路代金の注意事項を追加 */}
        {props.company === TaxiCompanyList.iyotetsutaxi &&
          <li>
            {/* 料金には、目的地または出発地により「高速道路代金」が含まれております。詳しくは、「予約確定メール」にてご確認下さい。 */}
          </li>
        }
      </ul>
      {/** AMCをサポートしている場合にはAMCの注意事項を追加する */}
      {props.isSupportAMC && props.isReservationPage &&
        <AMCCaution
          companyDisplayName={props.companyDisplayName}
          company={props.company}
        />
      }
    </div>
  );
}

export default CautionsEn;
